const id_master_goodsPrice = {
    "": "ubah harga",

    error: {
        update: 'Gagal mengubah data'
    },
    success: {
        update: 'Berhasil mengubah data'
    },
}

export default id_master_goodsPrice;